var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.choices))]),(_vm.value.choicesOther)?_c('span',{staticClass:"ml-2",domProps:{"textContent":_vm._s(_vm.value.choicesOther)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }